export interface YaraUnsubscribeResponse {
  unsubscribed: string[];
}
